import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Handle chunk loading errors by reloading the page once (browser-only)
// This fixes cache mismatches after deployments
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const isChunkError =
      event.message?.includes('Failed to fetch dynamically imported module') ||
      event.message?.includes('Importing a module script failed');

    if (isChunkError) {
      const hasReloaded = sessionStorage.getItem('chunk-error-reload');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-error-reload', 'true');
        console.warn('Chunk loading error detected, reloading page...');
        window.location.reload();
      } else {
        console.error('Chunk loading error persists after reload:', event.message);
        sessionStorage.removeItem('chunk-error-reload');
      }
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
